import React, { Component } from 'react';
import './Common.css';
import './BetControls.css';
import { deposit, withdraw, requestDefaultJudgment, requestArbitration, resolve } from "../actions/betActions"


class BetControls extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.getResolvedMessage = this.getResolvedMessage.bind(this);
        this.depositBetAmount = this.depositBetAmount.bind(this);
        this.depositArbitrationFee = this.depositArbitrationFee.bind(this);
        this.depositBoth = this.depositBoth.bind(this);
        this.withdraw = this.withdraw.bind(this);
        this.requestDefaultJudgment = this.requestDefaultJudgment.bind(this);
        this.requestArbitration = this.requestArbitration.bind(this);
        this.resolvePerson1 = this.resolvePerson1.bind(this);
        this.resolvePerson2 = this.resolvePerson2.bind(this);
        this.resolveTie = this.resolveTie.bind(this);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    getContext() {
        let betId = this.props.betId;
        console.log("BetControls");
        console.log(betId);
        let context = this.props.combinedStatus;
        console.log(context);
        return context;
    }

    handleButtonClick(event) {
        this.props.onClick(event.target.getAttribute("action"), event.target.getAttribute("param"));
    }

    depositBetAmount(event) {
        let context = this.getContext();
        this.props.dispatch(deposit(context.betId, context.yourBetAmount));
    }

    depositArbitrationFee(event) {
        let context = this.getContext();
        this.props.dispatch(deposit(context.betId, context.arbitrationFee));
    }

    depositBoth(event) {
        let context = this.getContext();
        this.props.dispatch(deposit(context.betId, (context.yourBetAmount + context.arbitrationFee)));
    }

    withdraw(event) {
        let context = this.getContext();
        this.props.dispatch(withdraw(context.betId));
    }

    requestDefaultJudgment(event) {
        let context = this.getContext();
        this.props.dispatch(requestDefaultJudgment(context.betId));
    }

    requestArbitration(event) {
        let context = this.getContext();
        this.props.dispatch(requestArbitration(context.betId, Math.max(0, context.arbitrationFee - context.yourArbitrationFeeBalance)));
    }

    resolvePerson1(event) {
        let context = this.getContext();
        this.props.dispatch(resolve(context.betId, context.RESOLUTION_PERSON1WINS));
    }

    resolvePerson2(event) {
        let context = this.getContext();
        this.props.dispatch(resolve(context.betId, context.RESOLUTION_PERSON2WINS));
    }

    resolveTie(event) {
        let context = this.getContext();
        this.props.dispatch(resolve(context.betId, context.RESOLUTION_TIE));
    }

    getResolvedMessage(prefixOverride, participantName, participantResolution, participant1, participant2) {
        const RESOLUTION_NONE = 0;

        const resolutionMessages = [
            "None",
            "@" + participant1 + " wins",
            "@" + participant2 + " wins",
            "It's a tie",
        ];

        let prefix = "@ " + participantName + " has";
        if(prefixOverride !== "") {
            prefix = prefixOverride;
        }

        return prefix + " " + (participantResolution === RESOLUTION_NONE ? "not yet resolved." : "resolved saying " + resolutionMessages[participantResolution].toLowerCase() + ".");
    }

    render() {  

        let context = this.getContext();
        if(context === null) {
            return null;
        }

        let moveLeft20 = false;

        return (

            <div className="">
                <div className="sectionTitle">{context.betStatusMsg} bet between @{context.participant1} and @{context.participant2}</div>

                {context.submitAttemptedNotFinal && (
                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput moveTop20 red">Bet has been finalized.  Waiting for blockchain deployment to complete.  Taking too long?  You can try redeploying your bet to blockchain.</label></td>
                        </tr>
                        <tr>
                            <td className="padAfter20">
                                <button className="btn">Redeploy to blockchain</button>
                            </td>
                        </tr>
                    </tbody></table>
                )}

                {context.finalAndMatching && (
                    <div>
                        {!context.onlyWithdrawAllowed && (
                            <div>
                                {!context.arbitrationRequested && (
                                    <div>
                                        {context.yourDepositNeeded > 0 && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">Waiting for you to deposit {context.yourDepositNeeded} ETH.  { context.yourBalance > 0 && "You've only deposited " + context.yourBalance + " ETH so far."}</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        <button onClick={this.depositBetAmount} className="btn">Deposit funds</button>
                                                        <button onClick={this.depositBoth} className="btn moveLeft20">Deposit funds + pre-pay arbitration fee of {context.arbitrationFee} ETH</button>
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                        {context.yourDepositNeeded === 0 && context.opponentDepositNeeded > 0 && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">Waiting for @{context.opponent} to deposit {context.opponentDepositNeeded} ETH. You've deposited {context.yourBalance} ETH.</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        <button onClick={this.withdraw} className="btn">Cancel bet and withdraw funds</button>
                                                        {context.yourArbitrationFeeBalance === 0 && <button onClick={this.depositArbitrationFee} className="btn moveLeft20">Pre-pay arbitration fee of {context.arbitrationFee} ETH</button>}
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                        {context.yourDepositNeeded === 0 && context.opponentDepositNeeded === 0 && context.yourResolution === context.RESOLUTION_NONE && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">{context.opponentResolution === context.RESOLUTION_NONE ? "Waiting for you and @" + context.opponent + " to enter bet resolutions" : "Waiting for you to enter a bet resolution.  @" + context.opponent + " has already resolved."}</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        {true && <button onClick={this.resolvePerson1} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON1WINS]}</button>}
                                                        {true && <button onClick={this.resolvePerson2} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON2WINS]}</button>}
                                                        {true && <button onClick={this.resolveTie} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_TIE]}</button>}
                                                        {context.yourArbitrationFeeBalance === 0 && <button onClick={this.depositArbitrationFee} className="btn moveLeft20">Pre-pay arbitration fee of {context.arbitrationFee} ETH</button>}
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                        {context.yourDepositNeeded === 0 && context.opponentDepositNeeded === 0 && context.yourResolution !== context.RESOLUTION_NONE && context.opponentResolution !== context.RESOLUTION_NONE && context.resolution === context.RESOLUTION_NONE && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">Waiting for you and @{context.opponent} to resolve your disagreement.  {this.getResolvedMessage("You said that", context.username, context.yourResolution, context.participant1, context.participant2)} {this.getResolvedMessage("They said that", context.opponent, context.opponentResolution, context.participant1, context.participant2)}  If you're not able to agree you may request arbitration.</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        {context.yourResolution !== context.RESOLUTION_PERSON1WINS && <button onClick={this.resolvePerson1} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON1WINS]}</button>}
                                                        {context.yourResolution !== context.RESOLUTION_PERSON2WINS && <button onClick={this.resolvePerson2} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON2WINS]}</button>}
                                                        {context.yourResolution !== context.RESOLUTION_TIE && <button onClick={this.resolveTie} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_TIE]}</button>}
                                                        <button onClick={this.requestArbitration} className="btn moveLeft20">Request arbitration</button>
                                                        {context.yourArbitrationFeeBalance === 0 && <button onClick={this.depositArbitrationFee} className="btn moveLeft20">Pre-pay arbitration fee of {context.arbitrationFee} ETH</button>}
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                        {context.username === context.arbiter && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">You are the arbiter for this bet, but arbitration has not been requested.  {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)} {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}</label></td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                    </div>
                                )}

                                {context.arbitrationRequested && !context.defaultJudgmentOccurred && (
                                    <div>
                                        {(context.username === context.participant1 || context.username === context.participant2) && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">Arbitration has been requested to resolve dispute.  Change your response to agree with @{context.opponent} if you'd like to avoid paying arbitration fee of {context.arbitrationFee} ETH.  {this.getResolvedMessage("You said that", context.username, context.yourResolution, context.participant1, context.participant2)} {this.getResolvedMessage("They said that", context.opponent, context.opponentResolution, context.participant1, context.participant2)} {context.yourArbitrationFeeBalance === 0 ? (context.remainingDaysBeforeJudgmentAllowed > 0 ? "You need to pay the arbitration fee of " + context.arbitrationFee + " ETH by " + context.momentArbitrationJudgmentAllowed.format("MM/DD/YYYY") + ", or your opponent can decided the outcome of this bet." : "You need to immediately pay the arbitration fee of " + context.arbitrationFee + " ETH.  Your opponent can decided the outcome of this bet since it's past the deadline of " + context.momentArbitrationJudgmentAllowed.format("MM/DD/YYYY") + ".") : ""}</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        {context.yourResolution !== context.RESOLUTION_PERSON1WINS && <button onClick={this.resolvePerson1} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON1WINS]}</button>}
                                                        {context.yourResolution !== context.RESOLUTION_PERSON2WINS && <button onClick={this.resolvePerson2} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON2WINS]}</button>}
                                                        {context.yourResolution !== context.RESOLUTION_TIE && <button onClick={this.resolveTie} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_TIE]}</button>}
                                                        {context.yourArbitrationFeeBalance === 0 && <button onClick={this.depositArbitrationFee} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>Pay arbitration fee of {context.arbitrationFee} ETH</button>}
                                                        {context.remainingDaysBeforeJudgmentAllowed === 0 && context.yourArbitrationFeeBalance === 0 && context.opponentArbitrationFeeBalance > 0 && <button onClick={this.requestDefaultJudgment} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>Request default judgment</button>}
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}

                                        {context.username === context.arbiter && (
                                            <table className="moveTop20"><tbody>
                                                <tr>
                                                    <td className="padAfter20"><label className="labelInput moveTop20 red">Arbitration has been requested to resolve dispute.  You are the arbiter for this bet.  Resolve the dispute and you'll be rewarded {context.arbitrationFee} ETH.  {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)} {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}</label></td>
                                                </tr>
                                                <tr>
                                                    <td className="padAfter20">
                                                        {true && <button onClick={this.resolvePerson1} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON1WINS]}</button>}
                                                        {true && <button onClick={this.resolvePerson2} className={"btn" + (moveLeft20 && (moveLeft20=true) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_PERSON2WINS]}</button>}
                                                        {true && <button onClick={this.resolveTie} className={"btn" + (moveLeft20 && (moveLeft20=false) ? "" : " moveLeft20")}>{context.resolutionMessages[context.RESOLUTION_TIE]}</button>}
                                                    </td>
                                                </tr>
                                            </tbody></table>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {context.onlyWithdrawAllowed && (
                            <div>

                                {context.youWon && context.yourBalance > 0 && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">Congratulations, you won the bet! Click "Withdraw funds" to get your {context.yourBalance} ETH (= {context.yourBetAmount} ETH as bet reward{context.yourArbitrationFeeBalance > 0 ? " and " + context.yourArbitrationFeeBalance + " ETH as unused arbitration fee" : ""}).  {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.arbiter, context.arbiterResolution, context.participant1, context.participant2)}</label></td>
                                        </tr>
                                        <tr>
                                            <td className="padAfter20">
                                                <button onClick={this.withdraw} className="btn">Withdraw funds</button>
                                            </td>
                                        </tr>
                                    </tbody></table>
                                )}

                                {context.youWon && context.yourBalance === 0 && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">Congratulations, you won the bet! Your funds have already been withdrawn to your account. {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.arbiter, context.arbiterResolution, context.participant1, context.participant2)}</label></td>
                                        </tr>
                                    </tbody></table>
                                )}

                                {context.opponentWon && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">Sorry, you lost the bet. {context.yourBalance > 0 && context.yourArbitrationFeeBalance > 0 ? "Click \"Withdraw funds\" to get your  " + context.yourArbitrationFeeBalance + " ETH as unused arbitration fee." : ""} {context.defaultJudgmentOccurred ? "A default Judgment was issued against you because you did not pay the arbitration fee by the deadline." : ""} {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.arbiter, context.arbiterResolution, context.participant1, context.participant2)}</label></td>
                                        </tr>
                                        {context.yourBalance > 0 && (
                                            <tr>
                                                <td className="padAfter20">
                                                    <button onClick={this.withdraw} className="btn">Withdraw funds</button>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody></table>
                                )}

                                {context.tieWon && context.yourBalance > 0 && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">The bet was a tie. Click "Withdraw funds" to get your {context.yourBalance} ETH (= {context.yourBetAmount} ETH as bet reward{context.yourArbitrationFeeBalance > 0 ? " and " + context.yourArbitrationFeeBalance + " ETH as unused arbitration fee" : ""}).  {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.arbiter, context.arbiterResolution, context.participant1, context.participant2)}</label></td>
                                        </tr>
                                        <tr>
                                            <td className="padAfter20">
                                                <button onClick={this.withdraw} className="btn">Withdraw funds</button>
                                            </td>
                                        </tr>
                                    </tbody></table>
                                )}

                                {context.tieWon && context.yourBalance === 0 && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">The bet was a tie. Your funds have already been withdrawn to your account. {this.getResolvedMessage("", context.participant1, context.person1Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.participant2, context.person2Resolution, context.participant1, context.participant2)}  {this.getResolvedMessage("", context.arbiter, context.arbiterResolution, context.participant1, context.participant2)}</label></td>
                                        </tr>
                                    </tbody></table>
                                )}

                                {context.resolution === context.RESOLUTION_NONE && (
                                    <table className="moveTop20"><tbody>
                                        <tr>
                                            <td className="padAfter20"><label className="labelInput moveTop20 red">This bet has been cancelled by you or @{context.opponent}.</label></td>
                                        </tr>
                                        {context.yourBalance > 0 && (
                                            <tr>
                                                <td className="padAfter20">
                                                    <button onClick={this.withdraw} className="btn">Withdraw funds</button>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody></table>
                                )}

                            </div>
                        )}

                    </div>
                )}
            </div>
        );
    }
  }
  
  export default BetControls;


// WEBPACK FOOTER //
// ./src/components/BetControls.js